// extracted by mini-css-extract-plugin
export default {"range":"RangeInputs_range__6PKU3"};